import usePlanFeatureValue from "frontend/hooks/use-plan-features";
import { useBoardValue } from "frontend/state/board-state";
import { PLAN_FEATURES_DEFAULT_VALUES, PlanFeatureName } from "shared/datamodel/schemas";

export const useGanttMaxTasks = () => {
  const boardValue = useBoardValue();

  const featureValue = usePlanFeatureValue(PlanFeatureName.GANTT_MAX_TASKS);
  if (boardValue?.[0]?.user?.isAnonymous) {
    return PLAN_FEATURES_DEFAULT_VALUES[PlanFeatureName.GANTT_MAX_TASKS];
  }
  return featureValue;
};
